import styled from 'styled-components';

export const StyledTableContainer = styled.div<{ isNotEmpty?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 92%;
  border-radius: 5px;
  text-overflow: ellipsis;
  .table-wrapper {
    overflow: auto;
    padding: unset;
    margin: 0;
    th:first-child,
    th:last-child {
      width: 64px;
    }
    td,
    th {
      text-align: left;
      padding: 12px 16px;
    }
    th:first-child {
      border-top-left-radius: 5px;
      width: fit-content;
    }
    th:last-child {
      border-top-right-radius: 5px;
    }
    tr:last-child {
      border-radius: 5px;
      td:first-child {
        border-bottom-left-radius: 5px;
      }
      td:last-child {
        border-bottom-right-radius: 5px;
      }
    }
  }
  .table-content {
    margin-top: 0px !important;
    height: calc(100% - 66px);
    min-height: 500px;
    overflow: auto;
  }

  .header-row {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #f5f7f9;
  }

  .table-actions {
    justify-content: flex-end;
    z-index: 10; // FSURVEY-6681
    width: 80%;
    border-bottom: 0;
    background: #fff;
    box-shadow: none;
    margin-bottom: 0;
    bottom: 0;
    right: 15px;
    position: fixed;
    padding-bottom: 5px;
  }

  ${({ isNotEmpty }) =>
    isNotEmpty
      ? `.pagination-text:before {
            content: 'Showing ';
          }`
      : `.pagination-actions {
            visibility: hidden;
          }`}

  .fui-table {
    display: flex;
  }
`;
